import { render, staticRenderFns } from "./newApply.vue?vue&type=template&id=d31e72c8&"
import script from "./newApply.vue?vue&type=script&lang=ts&"
export * from "./newApply.vue?vue&type=script&lang=ts&"
import style0 from "./newApply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports